// Briefe per Post (E-POST) an diesen Eigentümer.
import { BriefVerlauf } from '../../../dokumente/post/BriefVerlauf';
import { eigentuemerAnzeigename } from '../../../../../lib/eigentuemer/anzeige';
import { useEigSeite } from '../EigentuemerSeitenKontext';

export function BriefePanel() {
  const e = useEigSeite().daten.eigentuemer;
  return <BriefVerlauf art="eigentuemer" id={e.id} name={eigentuemerAnzeigename(e) || 'Eigentümer'} />;
}
